import styled from 'styled-components';

export const TocSettings = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;

  .heading-container{
    line-height:normal;
    text-align:center;
    height: 10%;
    align-content: center;
    margin-bottom: 20px;
  }
  .heading-text{
    color: white;
    padding: 5px;
    font-size: 27px;
    font-weight: bold;
    font-variant-caps: all-small-caps;
    background: #0297b2;
    text-align: center;
    -webkit-box-decoration-break: clone;
    border-radius: 10px;
  }

  .ant-radio-group{
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    gap:10px;
  }

  .ant-radio-button-wrapper{
    display: flex;
    height: 40px;
    text-align: center;
    align-items: center;
    justify-content: center;
    border-radius: 4px !important;
    margin: 10px 0px;
    background: #ffffff55;
    border: none;
    border-left: none !important;
    color: white;
  }
  .ant-radio-button-wrapper:hover{
    color: #8c52ff; 
  }
  .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
    background-color: #8c52ff;
    background: #8c52ff;
    color: #fff;
  }
  .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover{
    color: #fff;
    background-color: #9863ff;
    background: #9863ff;
  }

  .ant-radio-button-wrapper:not(:first-child)::before{
    display: none;
  }

  .ant-radio-button-wrapper-disabled.ant-radio-button-wrapper-checked{
    color: #fff;
    background-color: #9863ff;
    background: #9863ff;
    border: none;
  }

  .input-container{
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px 0px 15px 0px;
    .ant-typography{
      font-size: 18px;
      color: white;
      font-weight: bold;
      font-variant-caps: all-small-caps;
    }
    .ant-input{
      background: #000; //hsla(0,0%,100%,0.07)
      color: #fff;
      padding: 5px;
    }
    .ant-input:hover{
      border-color: #9863ff;
    }
  }

  .switch-container{
    display: flex;
    width: 100%;
    padding: 10px;
    align-items: center;
    justify-content: space-between;
    background: #ffffff; // hsla(0,0%,100%,0.07)
    border-radius: 4px;
    margin: 10px 0px;
    .ant-typography{
      position: relative;
      top: -1px;
      font-size: 18px;
      color: #000;
      font-variant-caps: all-small-caps;
      font-weight: bold;
    }
    .ant-switch-checked {
      background-color: #9863ff !important;
  }
  }
`;
